import { REGISTRATION_STATE } from "../config/registration-state.js";
import { legalHeaderMarkup } from "../components/legal-site-chrome.js";
import { createColdTrailCompositor } from "../visuals/cold-trail-compositor.js";

export function bootContactPage(app, { still = false } = {}) {
  document.body.dataset.page = "contact";
  document.title = "Exiled Systems — Contact Staff";
  app.innerHTML = `
    <div class="legal-experience contact-experience">
      <canvas class="cold-trail" data-cold-trail aria-hidden="true"></canvas>
      <div class="legal-atmosphere" aria-hidden="true"></div>
      ${legalHeaderMarkup("contact")}
      <main class="contact-main" id="main-content">
        <section class="contact-panel">
          <p class="legal-eyebrow"><i></i> STAFF RELAY // OFFLINE</p>
          <h1>Contact Staff</h1>
          <p>The secure staff-contact workflow is not connected yet. No message, attachment, email address, or private information is collected on this page.</p>
          <div class="contact-state" role="status"><i aria-hidden="true"></i><span><strong>CONTACT CHANNEL LOCKED</strong>Monitored routing, abuse protection, privacy handling, and response ownership must be completed before activation.</span></div>
          <nav aria-label="Contact page actions"><a href="/">Return home</a><a href="${REGISTRATION_STATE.termsRoute}">Review Terms draft</a><button type="button" data-motion-toggle>Pause background</button></nav>
        </section>
      </main>
      <footer class="legal-footer"><span>© 2026 EXILED SYSTEMS</span><span>STAFF CONTACT // COMING SOON</span></footer>
    </div>`;
  const compositor = createColdTrailCompositor(app.querySelector("[data-cold-trail]"), { still });
  app.querySelector("[data-motion-toggle]").addEventListener("click", (event) => {
    const running = compositor.toggle();
    event.currentTarget.textContent = running ? "Pause background" : "Resume background";
    event.currentTarget.setAttribute("aria-pressed", String(!running));
  });
  window.__EXILED_CONTACT__ = Object.freeze({ ready: true, enabled: false, mutationRequests: false, compositor: compositor.getState() });
}

